module.exports = __webpack_public_path__ + "static/media/arrow-down2.c2de674f.svg";